import { withTranslation, Trans } from "next-i18next";
import classNames from "classnames";

const options = [
  "take_a_size_up",
  "smaller_than_normal_size",
  "normal_size",
  "larger_than_normal_size",
  "take_a_size_down",
]

function ProductFits({ product = {} }) {
  const { fits, recommendations } = product;

  function displayFitBars() {
    return options.map((option) => (
      <div
        key={option}
        className={classNames("product-fits-bar", option === recommendations && "recommended")}
      />
    ));
  }

  return (
    <div className="product-fits mb-3">
      <div className="product-fits-bars-container">
        {displayFitBars()}
      </div>
      <div className="product-fits-labels-container">
        <span className="font-size-xs text-gray text-uppercase">
          <Trans
            i18nKey="product:too_small_count"
            values={{ count: fits.too_small_count }}
            components={[<span className="text-dark font-weight-bold" key="first" />]}
          />
        </span>
        <span className="font-size-xs text-gray text-uppercase text-center">
          <Trans
            i18nKey="product:perfect_count"
            values={{ count: fits.perfect_count }}
            components={[<span className="text-dark font-weight-bold" key="first" />]}
          />
        </span>
        <span className="font-size-xs text-gray text-uppercase text-end">
          <Trans
            i18nKey="product:too_large_count"
            values={{ count: fits.too_large_count }}
            components={[<span className="text-dark font-weight-bold" key="first" />]}
          />
        </span>
      </div>
    </div>
  );
}

export default withTranslation("product")(ProductFits);
